import * as Ajv from "ajv";
import { createAjvDraft07Compat } from "./ajv_compat";
import { Reviver, revivers } from "./MessageRevivers";

// needed auto-generated module (created from schema_gen.js)
import { getMessagesSchemas } from "./message_schemas";

const validators = new Map<string, Ajv.ValidateFunction>();

const ajv = createAjvDraft07Compat({
  removeAdditional: true,
});

/**
 * See this for an explanation:
 * <https://github.com/YousefED/typescript-json-schema/issues/98#issuecomment-349733289>
 */
const validateFn = (
  keywordValue: string,
  data: any,
  _parentSchema?: object,
  dataPath?: string,
  parentData?: object | any[],
  parentDataProperty?: string | number,
  _rootData?: object | any[]
): boolean => {
  const setErrorMessage = (msg: string): void => {
    (<any>validateFn).errors = [
      {
        keyword: "xreviver",
        dataPath: "" + dataPath,
        schemaPath: "", // This field appears to be ignored
        params: {
          keyword: "xreviver",
        },
        message: msg,
        data: data,
      },
    ];
  };

  if (typeof data === "string") {
    const reviverFn: Reviver | undefined = <any>revivers[keywordValue];
    if (reviverFn === undefined) {
      setErrorMessage(`Unknown xreviver function: "${keywordValue}"`);
      return false;
    }

    let parsed: any;
    try {
      parsed = reviverFn(data);
    } catch (e) {
      // Take only the first line, because the rest may contain junk (a stack trace)
      const parseError = e.message.split("\n")[0];

      setErrorMessage(`${keywordValue}: ${parseError}`);
      return false;
    }
    if (parentData !== undefined && parentDataProperty !== undefined) {
      (<any>parentData)[parentDataProperty] = parsed;
    }
  }
  return true;
};

ajv.addKeyword("xreviver", {
  modifying: true,
  validate: validateFn,
});

getMessagesSchemas().forEach((value) => {
  // Since I changed message_gen.js to a TS file, then TSC statically checks the types and now
  // it warns that typeName and schema probably won't always be string an object. I have set them "as"
  // since I don't want to break the current behavior.
  const typeName = value[0] as string;
  const schema = value[1] as object;

  if (validators.has(typeName)) {
    throw new Error(`Duplicate schema found for type: ${typeName}`);
  }

  validators.set(typeName, ajv.compile(schema));
});

/**
 * Fully qualified name of a message (they all must be listed in `messages.json`)
 */
export type MessageName = string;

/**
 * The typeNames available will be those listed in `messages.json`
 *
 * Example:
 *
 *     import { messageValidator } from './MessageValidation';
 *
 *     const validate = messageValidator('Messages.Person');
 *     const valid = validate({"age":3, name":"john"});
 *     console.log(valid);
 *     console.log(validate.errors);
 *
 * See the documentation of <https://github.com/epoberezkin/ajv> for more info.
 */
export function messageValidator(typeName: MessageName): Ajv.ValidateFunction {
  const lookupResult = validators.get(typeName);
  if (lookupResult === undefined) {
    throw new Error(
      `Message "${typeName}" does not exist. Check that it is listed in "messages.json"`
    );
  }

  return lookupResult;
}
